import { render } from "./ContentStruktur.vue?vue&type=template&id=365ebf41&scoped=true"
import script from "./ContentStruktur.vue?vue&type=script&lang=js"
export * from "./ContentStruktur.vue?vue&type=script&lang=js"

import "./ContentStruktur.vue?vue&type=style&index=0&id=365ebf41&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365ebf41"]])

export default __exports__